import styled from 'styled-components';
import { BRAND_AFFINITY } from 'utils/fieldConstants';
import { AiColor16 } from 'ui/icons/aurora/16px/AiColor16';
import { pxToRem } from 'utils/convert';

const StyledWrapper = styled.div`
  margin-top: ${pxToRem(-2)};
  display: inline-block;
  margin-right: ${pxToRem(5)};
`;

export const DropdownIcon = ({ value }) => {
  return value === BRAND_AFFINITY ? (
    <StyledWrapper>
      <AiColor16 />
    </StyledWrapper>
  ) : null;
};
